// extracted by mini-css-extract-plugin
export default {"buyPage":"Buy_buyPage__5OBBM","container":"Buy_container__lczRc","companies":"Buy_companies__S6GZ4","image":"Buy_image__OZuG0"};